const MiniSpectrum = ({ perspectives, spectrumLeft, spectrumRight, compact = false }) => {
  const dotSize = compact ? 16 : 24;
  const height = compact ? 22 : 36;
  const fontSize = compact ? '8px' : '9px';

  const count = perspectives.length;
  const positions = perspectives.map((p) => {
    const pos = p.spectrumPosition;
    if (typeof pos === 'number' && pos >= 0 && pos <= 100) return pos;
    return 50;
  });
  if (count === 1) positions[0] = 50;

  return (
    <div className={compact ? 'py-1' : 'py-3 pb-1'}>
      <div
        className="relative"
        style={{ height: `${height}px`, marginBottom: compact ? '2px' : '4px' }}
      >
        {/* Spectrum line */}
        <div
          className="absolute left-0 right-0 rounded-full"
          style={{
            top: `${height / 2}px`,
            height: compact ? '2px' : '3px',
            background:
              'linear-gradient(to right, rgba(226,232,240,0.12), rgba(148,163,184,0.19), rgba(226,232,240,0.12))'
          }}
        />

        {/* Persona dots */}
        {perspectives.map((p, i) => (
          <div
            key={i}
            className="absolute flex flex-col items-center"
            style={{
              left: `${positions[i]}%`,
              top: compact ? '3px' : '4px',
              transform: 'translateX(-50%)',
              zIndex: 5
            }}
          >
            <div className="relative">
              <div
                className="rounded-full flex items-center justify-center text-white font-bold"
                style={{
                  width: `${dotSize}px`,
                  height: `${dotSize}px`,
                  background: p.personaColor || p.color || '#6366f1',
                  fontSize: compact ? '0' : '8px',
                  fontFamily: "'JetBrains Mono', monospace",
                  boxShadow: p.isCommunity
                    ? `0 0 0 ${compact ? '1.5px' : '2px'} white, 0 0 0 ${compact ? '2.5px' : '3.5px'} #059669`
                    : compact
                      ? '0 0 0 1.5px white'
                      : '0 1px 3px rgba(0,0,0,0.15)'
                }}
              >
                {!compact &&
                  (p.personaName || '')
                    .split(' ')
                    .map((n) => n[0])
                    .join('')
                    .slice(0, 2)}
              </div>
              {!compact && !p.isCommunity && (
                <div
                  className="absolute font-extrabold rounded-sm border border-white"
                  style={{
                    bottom: '-1px',
                    right: '-3px',
                    background: '#0f172a',
                    color: '#a5f3fc',
                    fontSize: '5px',
                    padding: '1px 2px',
                    fontFamily: "'JetBrains Mono', monospace"
                  }}
                >
                  AI
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Labels */}
      {!compact && (
        <div className="flex justify-between">
          <span
            className="text-slate-400 font-semibold"
            style={{ fontSize, fontFamily: "'JetBrains Mono', monospace" }}
          >
            {spectrumLeft || 'Left'}
          </span>
          <span
            className="text-slate-400 font-semibold"
            style={{ fontSize, fontFamily: "'JetBrains Mono', monospace" }}
          >
            {spectrumRight || 'Right'}
          </span>
        </div>
      )}
    </div>
  );
};

export default MiniSpectrum;
